import {without} from 'es-toolkit'

import {Permission} from '../types'

export const anyPermission = Object.values(Permission)
export const anyPermissionExceptOperator = without(anyPermission, Permission.PROVIDER_OPERATOR)

export const isAdminModePermission = (permission: Permission) =>
  permission === Permission.ADMIN || permission === Permission.READ_ONLY
